import { DriveOnTargetDto as Target } from '@/generated/model/driveOnTargetDto';
import { useTranslation } from 'react-i18next';

import './TargetList.css';

type TargetListProps = {
  title: string;
  targets: Target[] | undefined;
  setTarget: (target: Target) => void;
  distance: boolean;
  targetsHistory: boolean;
};

export function TargetList({ title, targets, setTarget, distance, targetsHistory }: TargetListProps) {
  const { t } = useTranslation();
  if (!targets) return null;

  function getLastUsage(target: Target): string | 0 | undefined {
    const timeOptions = { month: '2-digit', day: '2-digit' } satisfies Intl.DateTimeFormatOptions;
    const timeMicros = targets?.filter((t) => t.id == target.id).map((t) => t.lastUsageMicros)[0];
    const toTime = timeMicros && new Date(timeMicros / 1000).toLocaleString('hu-HU', timeOptions);
    return toTime;
  }

  return (
    <div className="target-list">
      <div className="title">{title}</div>
      {targets.length !== 0
        ? targets.map((v) => (
            <div key={v.name} onClick={() => setTarget(v)}>
              <div className="plate">
                {v.name} {v.egs && ' (EGS)'}
              </div>
              <div className="description">{v.vehicleCategory}</div>
              {distance && <div className="distance">Távolság: {v.distance && (v.distance | 0) / 1000} km</div>}
              {targetsHistory && <div className="distance">Legutóbb: {getLastUsage(v)}</div>}
            </div>
          ))
        : t('menetlevel.choosevehicle.novehicles')}
    </div>
  );
}
